var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable, onModuleInit } from '@tokamakjs/injection';
import { bootstrap } from "../bootstrap";
let AppService = class AppService {
    bootstrap() {
        return bootstrap();
    }
};
__decorate([
    onModuleInit(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppService.prototype, "bootstrap", null);
AppService = __decorate([
    Injectable()
], AppService);
export { AppService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYXBwL3NlcnZpY2VzL2FwcC5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsWUFBWSxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFFaEUsT0FBTyxFQUFFLFNBQVMsRUFBRSxxQkFBb0I7QUFHeEMsSUFBYSxVQUFVLEdBQXZCLE1BQWEsVUFBVTtJQUVyQixTQUFTO1FBQ1AsT0FBTyxTQUFTLEVBQUUsQ0FBQztJQUNyQixDQUFDO0NBQ0YsQ0FBQTtBQUhDO0lBREMsWUFBWSxFQUFFOzs7OzJDQUdkO0FBSlUsVUFBVTtJQUR0QixVQUFVLEVBQUU7R0FDQSxVQUFVLENBS3RCO1NBTFksVUFBVSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEluamVjdGFibGUsIG9uTW9kdWxlSW5pdCB9IGZyb20gJ0B0b2thbWFranMvaW5qZWN0aW9uJztcblxuaW1wb3J0IHsgYm9vdHN0cmFwIH0gZnJvbSAnfi9ib290c3RyYXAnO1xuXG5ASW5qZWN0YWJsZSgpXG5leHBvcnQgY2xhc3MgQXBwU2VydmljZSB7XG4gIEBvbk1vZHVsZUluaXQoKVxuICBib290c3RyYXAoKSB7XG4gICAgcmV0dXJuIGJvb3RzdHJhcCgpO1xuICB9XG59XG4iXX0=